import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { List, Tooltip, Comment, Form, Button } from 'antd'
import moment from 'moment'
import TextArea from 'antd/lib/input/TextArea'
import { createComment, deleteComment, getComments } from './actions'
import { orderBy } from 'lodash'


const Editor = ({ onChange, onSubmit, submitting, value, formatMessage }) => (
  <div>
    <Form.Item>
      <TextArea rows={4} onChange={onChange} value={value} />
    </Form.Item>
    <Form.Item>
      <Button htmlType="submit" disabled={!value} loading={submitting} onClick={onSubmit} type="primary">
        {formatMessage('addBtnComment')}
      </Button>
    </Form.Item>
  </div>
);

class CommentBlock extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
       value: '',
       submitting: false,
       loaded: false,
       comments: [],
    }
  }
  
  async componentDidMount(){
    try {
      const {questionId} = this.props;
      const comments = await getComments(questionId);
      this.setState({
        loaded: true,
        comments
      })
    } catch (error) {
      this.setState({
        loaded: true,
        comments: []
      })
    }
    
  }

  handleSubmit = async () => {
    const {questionId} = this.props;
    const { value } = this.state;
    this.setState({submitting: true})
    const comments = await createComment({
      text: value,
      question_id: questionId
    })
    this.setState({submitting: false, value: '', comments})
  }

  handleDelete = async (_i) => {
    this.setState({loaded: false});
    const comments = await deleteComment(_i);
    this.setState({loaded: true, comments});
  }

  handleChange = (e) => {
    this.setState({value: e.target.value})
  }

  render() {
    const {value, submitting, loaded, comments } = this.state;
    const {questionId, formatMessage} = this.props;
    const data = orderBy((comments || []), ['created_at'], ['desc']).map(_i => {
      return {
        key: _i.id + '_' + questionId,
        actions: [<span key="comment-list-reply-to-0" onClick={() => this.handleDelete(_i)}>{formatMessage('deleteComment')}</span>],
        content: (
          <p>
           {_i.text}
          </p>
        ),
        datetime: (
          <Tooltip
            title={moment(_i.created_at * 1000)
              .format('YYYY-MM-DD HH:mm:ss')}
          >
            <span>
              {moment(_i.created_at * 1000)
                .fromNow()}
            </span>
          </Tooltip>
        ),
      };
    });


    return (
      <div>
        <Comment
          content={
            <Editor
              onChange={this.handleChange}
              onSubmit={this.handleSubmit}
              submitting={submitting}
              value={value}
              formatMessage={formatMessage}
            />
          }
        />
        <List
          className="comment-list"
          // header={`${data.length} replies`}
          itemLayout="horizontal"
          loading={!loaded}
          dataSource={data}
          renderItem={item => (
            <li key={item.key + '-' + questionId}>
              <Comment
                actions={item.actions}
                author={item.author}
                avatar={item.avatar}
                content={item.content}
                datetime={item.datetime}
              />
            </li>
          )}
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  questions: state.questions.entities,
})

const mapDispatchToProps = {
  // createComment,
  deleteComment,
}

export default connect(mapStateToProps, mapDispatchToProps)(CommentBlock)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmBody/QuestionForm/components/Comments/Comments.jsx